export async function initVideoJS() {
  if (window.videojs) {
    return window.videojs;
  }
  return await new Promise(resolve => {
    if (window.domHasLoaded) {
      return resolve();
    }
    document.addEventListener('DOMContentLoaded', resolve);
  })
  .then(() => new Promise(resolve => {
    window.addEventListener('videojs:loaded', (e) => resolve(window.videojs));
    if (!document.head.querySelector('#video-js-main')) {
      const script = document.createElement('script');
      script.setAttribute('defer', 'true');
      script.setAttribute('id', 'video-js-main');
      script.setAttribute('src', '//de.paul-valentine.com/cdn/shop/t/431/assets/video.min.js?v=89844687214356902831746787773');
      script.addEventListener('load', () => {
        window.dispatchEvent(new Event('videojs:loaded'));
      });
      document.head.appendChild(script);
      const stylesheet = document.createElement('link');
      stylesheet.setAttribute('id', 'video-js-style');
      stylesheet.setAttribute('rel', 'stylesheet');
      stylesheet.setAttribute('href', '//de.paul-valentine.com/cdn/shop/t/431/assets/video-js.css?v=12882655448658564831746787824');
      stylesheet.setAttribute('media', 'all');
      document.head.appendChild(stylesheet);
    }
  }));
}


async function initPlayer(element, autoplay) {
  const videojs = window.videojs = await initVideoJS();
  const player = videojs(element);
  element.addEventListener('touchstart', (e) => {
    if (e.target.closest('.vjs-control-bar')) {
      return;
    }
    let touchstarttime = performance.now();
    function touchend(e) {
      const touchendtime = performance.now();
      if (touchendtime - touchstarttime < 500) {
        if (player.paused() || player.currentTime() === 0) {
          player.play();
        } else {
          player.pause();
        }
      }
      element.removeEventListener('touchend', touchend);
    }
    element.addEventListener('touchend', touchend, { passive: true });
  }, { passive: true });
  if (autoplay) {
    initAutoplay(element);
  }
};

function createObserver(handleIntersect, element) {
  let observer;
  let options = {
      rootMargin: "500px 0px 0px 0px"
  };
  observer = new IntersectionObserver((entries, observer) => {
    if (entries.some(entry => entry.isIntersecting)) {
      handleIntersect(element, observer);
    }
  }, options);
  observer.observe(element);
}

/*
  Autoplay only works after user-interaction, with slightly different behaviour between browsers.
  This should work everywhere if the user has touched, tapped, clicked before and the video   comes into view for the first time. Will try until play succeeds for the first time.
*/
function initAutoplay(element) {
  const interactionEvents = [
  'scroll', 'resize', 'touchstart', 'touchend', 'touchmove', 'mousedown',
    'mouseup', 'mousemove', 'click', 'keydown', 'keyup'
  ];
  function handleIntersect(element, observer) {
    const playOnce = (() => {
      let played = false;
      return async (e) => {
        if (!played) {
          try {
            await player.play();
            played = true;
            observer.disconnect();
            for (const e of interactionEvents) {
              document.removeEventListener(e, playOnce);
            }
          } catch (err) {
            console.warn('failed to play on event', e);
          }
        }
      }
    })();
    for (const e of interactionEvents) {
      document.addEventListener(e, playOnce, { passive: true });
    }
    playOnce();
  }
  createObserver(handleIntersect, element);
}



export async function initVideo(id, options, lazy = true) {
  const autoplay = options && (typeof options !== 'object' || options.autoplay);
  lazy = lazy || (typeof lazy === 'undefined' && options && options.lazy);
  const elements = document.querySelectorAll(`video-js[bc-touch-video="${id}"]`);

  elements.forEach(element => {
    if (!lazy) {
      initPlayer(element, autoplay);
    } else {
      createObserver((element, observer) => {
        initPlayer(element, autoplay);
        observer.disconnect();
      }, element);
    }
  });
};
